/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'

import { useBackgroundStyle } from '../../utils/styles/background'
import { useBgPatternsStyle } from '../../utils/styles/backgroundPatterns'
import { useBorderStyle } from '../../utils/styles/border'
import { useDisplayStyle } from '../../utils/styles/display'
import { useGridStyle } from '../../utils/styles/grid'
import { useMarginStyle } from '../../utils/styles/margin'
import { usePaddingStyle } from '../../utils/styles/padding'
import { useScrollStyle } from '../../utils/styles/scroll'
import { useSizeStyle } from '../../utils/styles/size'

const Background = ({ children, ...props }) => {
  const style = css`
    ${useGridStyle(props)}
    ${useBorderStyle({ radius: 0.5, ...props })}
    ${useSizeStyle(props)}
    ${useScrollStyle(props)}
    ${usePaddingStyle({ padding: 1.25, ...props })}
    ${useMarginStyle(props)}
    ${useDisplayStyle(props)}
    ${useBackgroundStyle(props)}
    ${useBgPatternsStyle(props)}
  `

  return (
    <div className="background" css={style} {...props}>
      {children}
    </div>
  )
}

export default Background
